import { useQuery } from '@tanstack/react-query';
import type { Lesson } from '@court-sync/shared';
import type { PaginationState } from '@/components/ui/PaginatedTable';
import {
  lessonService,
  type PublicLessonBrowseParams,
} from '@/services/lesson';
import { STALE_TIME } from '@/queryClient';
import { queryKeys } from './keys';

export function usePublicLessonBrowse(
  academyId: string | undefined,
  params: PublicLessonBrowseParams,
  options?: { enabled?: boolean }
) {
  const enabled = (options?.enabled ?? true) && !!academyId;

  return useQuery({
    queryKey: queryKeys.lessons.publicBrowse(academyId ?? '', params),
    queryFn: async (): Promise<{ data: Lesson[]; pagination: PaginationState }> =>
      lessonService.getPublicLessonsBrowse(academyId!, params),
    enabled,
    staleTime: STALE_TIME.MEDIUM,
    placeholderData: (previous) => previous,
  });
}
